import { NutritionProduct } from '../types'

export const DEFAULT_PRODUCTS: NutritionProduct[] = [
  {
    id: 'maurten-gel-100',
    name: 'Maurten Gel 100',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'maurten-gel-160',
    name: 'Maurten Gel 160',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'maurten-gel-100-caf',
    name: 'Maurten Gel 100 CAF 100',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'gu-roctane',
    name: 'GU Roctane Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'gu-energy-gel',
    name: 'GU Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'sisprogel',
    name: 'SiS GO Isotonic Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 87,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'sisbeta-fuel-gel',
    name: 'SiS Beta Fuel Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'nduranz-gel',
    name: 'Nduranz Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 95,
  },
  {
    id: 'precision-fuel-gel',
    name: 'Precision Fuel & Hydration PF 30 Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'spring-energy-awesome',
    name: 'Spring Energy Awesome Sauce',
    unitLabel: 'gel',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'spring-energy-canaberry',
    name: 'Spring Energy Canaberry',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 40,
  },
  {
    id: 'tailwind-endurance',
    name: 'Tailwind Endurance Fuel',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'maurten-320',
    name: 'Maurten Drink Mix 320',
    unitLabel: 'sachet',
    carbsPerUnitG: 80,
    caloriesPerUnitKcal: 320,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'maurten-160',
    name: 'Maurten Drink Mix 160',
    unitLabel: 'sachet',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'sis-go-electrolyte',
    name: 'SiS GO Electrolyte',
    unitLabel: 'scoop',
    carbsPerUnitG: 36,
    caloriesPerUnitKcal: 144,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'nduranz-nrg-units',
    name: 'Nduranz Nrg Units Drink',
    unitLabel: 'sachet',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'precision-pf-carb',
    name: 'Precision Fuel PF Carb & Electrolyte',
    unitLabel: 'sachet',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'clif-bar',
    name: 'Clif Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 250,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'clif-bloks',
    name: 'Clif Bloks (sleeve)',
    unitLabel: 'sleeve',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 70,
  },
  {
    id: 'maurten-solid',
    name: 'Maurten Solid 225',
    unitLabel: 'bar',
    carbsPerUnitG: 56,
    caloriesPerUnitKcal: 225,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'maurten-solid-160',
    name: 'Maurten Solid 160',
    unitLabel: 'bar',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'spring-energy-speednut',
    name: 'Spring Energy Speed Nut',
    unitLabel: 'pack',
    carbsPerUnitG: 33,
    caloriesPerUnitKcal: 250,
    sodiumPerUnitMg: 30,
  },
  {
    id: 'precision-1000',
    name: 'Precision Fuel 1000mg Capsule',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'precision-500',
    name: 'Precision Fuel 500mg Capsule',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'saltstick-cap',
    name: 'SaltStick Cap',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 215,
  },
  {
    id: 'banana',
    name: 'Banana (medium)',
    unitLabel: 'unit',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 1,
  },
  {
    id: 'dates-medjool',
    name: 'Medjool Dates (2 pcs)',
    unitLabel: '2 pcs',
    carbsPerUnitG: 36,
    caloriesPerUnitKcal: 133,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'boiled-potato',
    name: 'Boiled Potato (small)',
    unitLabel: 'unit',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 80,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'sandwich-jam',
    name: 'Jam Sandwich (half)',
    unitLabel: 'half',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'rice-cake',
    name: 'Rice Cake (homemade)',
    unitLabel: 'piece',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 80,
  },
  {
    id: 'powerbar-energy-gel',
    name: 'PowerBar Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-powergel-shots',
    name: 'PowerBar PowerGel Shots',
    unitLabel: 'pack',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'decathlon-aptogn',
    name: 'Aptonia Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'enervit-gel',
    name: 'Enervit Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'high5-energy-gel',
    name: 'High5 Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'isostar-hydrate',
    name: 'Isostar Hydrate & Perform',
    unitLabel: 'scoop',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 240,
  },
  {
    id: 'coca-cola',
    name: 'Coca-Cola',
    unitLabel: 'cup',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'flat-cola',
    name: 'Flat Cola',
    unitLabel: 'cup',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'orange-slices',
    name: 'Orange Slices',
    unitLabel: 'cup',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 80,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'apple-slices',
    name: 'Apple Slices',
    unitLabel: 'cup',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 95,
    sodiumPerUnitMg: 2,
  },
  {
    id: 'watermelon',
    name: 'Watermelon',
    unitLabel: 'cup',
    carbsPerUnitG: 11,
    caloriesPerUnitKcal: 45,
    sodiumPerUnitMg: 2,
  },
  {
    id: 'pretzels',
    name: 'Pretzels',
    unitLabel: 'handful',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'salted-chips',
    name: 'Salted Chips',
    unitLabel: 'small pack',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 150,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'white-bread',
    name: 'White Bread Slice',
    unitLabel: 'slice',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 80,
    sodiumPerUnitMg: 130,
  },
  {
    id: 'cheese-cubes',
    name: 'Cheese Cubes',
    unitLabel: 'portion',
    carbsPerUnitG: 2,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'ham-slices',
    name: 'Ham Slices',
    unitLabel: 'portion',
    carbsPerUnitG: 1,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 350,
  },
  {
    id: 'soup-broth',
    name: 'Soup / Broth',
    unitLabel: 'cup',
    carbsPerUnitG: 5,
    caloriesPerUnitKcal: 40,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'instant-noodles',
    name: 'Instant Noodles',
    unitLabel: 'cup',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 190,
    sodiumPerUnitMg: 900,
  },
  {
    id: 'pasta-white',
    name: 'White Pasta',
    unitLabel: 'cup',
    carbsPerUnitG: 42,
    caloriesPerUnitKcal: 210,
    sodiumPerUnitMg: 20,
  },
  {
    id: 'rice-white',
    name: 'White Rice',
    unitLabel: 'cup',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 205,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'mashed-potato',
    name: 'Mashed Potato',
    unitLabel: 'cup',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'scrambled-eggs',
    name: 'Scrambled Eggs',
    unitLabel: 'portion',
    carbsPerUnitG: 2,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 160,
  },
  {
    id: 'pizza-slice',
    name: 'Pizza Slice',
    unitLabel: 'slice',
    carbsPerUnitG: 36,
    caloriesPerUnitKcal: 285,
    sodiumPerUnitMg: 640,
  },
  {
    id: 'burger-half',
    name: 'Burger (half)',
    unitLabel: 'half',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 260,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'rice-pudding',
    name: 'Rice Pudding',
    unitLabel: 'cup',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 220,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'yogurt-sweet',
    name: 'Sweet Yogurt',
    unitLabel: 'cup',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 130,
    sodiumPerUnitMg: 90,
  },
  {
    id: 'tailwind-endurance-naked',
    name: 'Tailwind Endurance Fuel (Naked)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-lemon',
    name: 'Tailwind Endurance Fuel (Lemon)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-mandarin',
    name: 'Tailwind Endurance Fuel (Mandarin)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-berry',
    name: 'Tailwind Endurance Fuel (Berry)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-raspberry-buzz-caffeine',
    name: 'Tailwind Endurance Fuel (Raspberry Buzz (Caffeine))',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-green-tea-buzz-caffeine',
    name: 'Tailwind Endurance Fuel (Green Tea Buzz (Caffeine))',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-colorado-cola',
    name: 'Tailwind Endurance Fuel (Colorado Cola)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-tropical-buzz-caffeine',
    name: 'Tailwind Endurance Fuel (Tropical Buzz (Caffeine))',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-salted-caramel',
    name: 'Tailwind Endurance Fuel (Salted Caramel)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-endurance-ginger-lime',
    name: 'Tailwind Endurance Fuel (Ginger Lime)',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-rapid-hydration-naked',
    name: 'Tailwind Rapid Hydration (Naked)',
    unitLabel: 'scoop',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-rapid-hydration-lemon-lime',
    name: 'Tailwind Rapid Hydration (Lemon Lime)',
    unitLabel: 'scoop',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-rapid-hydration-berry',
    name: 'Tailwind Rapid Hydration (Berry)',
    unitLabel: 'scoop',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-rapid-hydration-mango',
    name: 'Tailwind Rapid Hydration (Mango)',
    unitLabel: 'scoop',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-rapid-hydration-grapefruit',
    name: 'Tailwind Rapid Hydration (Grapefruit)',
    unitLabel: 'scoop',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 303,
  },
  {
    id: 'tailwind-recovery-chocolate',
    name: 'Tailwind Recovery Mix (Chocolate)',
    unitLabel: 'scoop',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 190,
  },
  {
    id: 'tailwind-recovery-vanilla',
    name: 'Tailwind Recovery Mix (Vanilla)',
    unitLabel: 'scoop',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 190,
  },
  {
    id: 'tailwind-recovery-salted-caramel',
    name: 'Tailwind Recovery Mix (Salted Caramel)',
    unitLabel: 'scoop',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 190,
  },
  {
    id: 'tailwind-recovery-coffee',
    name: 'Tailwind Recovery Mix (Coffee)',
    unitLabel: 'scoop',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 190,
  },
  {
    id: 'tailwind-recovery-dairy-free-chocolate',
    name: 'Tailwind Recovery Mix (Dairy-Free Chocolate)',
    unitLabel: 'scoop',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 190,
  },
  {
    id: 'maurten-drink-mix-160-caf',
    name: 'Maurten Drink Mix 160 CAF',
    unitLabel: 'sachet',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'maurten-drink-mix-320-caf',
    name: 'Maurten Drink Mix 320 CAF',
    unitLabel: 'sachet',
    carbsPerUnitG: 80,
    caloriesPerUnitKcal: 320,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'maurten-bicarb-system',
    name: 'Maurten Bicarb System',
    unitLabel: 'serving',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'sis-go-energy-mini-bar',
    name: 'SiS GO Energy Mini Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 35,
  },
  {
    id: 'sis-go-energy-bake',
    name: 'SiS GO Energy Bake',
    unitLabel: 'bar',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'sis-go-electrolyte-orange',
    name: 'SiS GO Electrolyte (Orange)',
    unitLabel: 'scoop',
    carbsPerUnitG: 36,
    caloriesPerUnitKcal: 144,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'sis-go-electrolyte-lemon-lime',
    name: 'SiS GO Electrolyte (Lemon & Lime)',
    unitLabel: 'scoop',
    carbsPerUnitG: 36,
    caloriesPerUnitKcal: 144,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'sis-go-electrolyte-berry',
    name: 'SiS GO Electrolyte (Berry)',
    unitLabel: 'scoop',
    carbsPerUnitG: 36,
    caloriesPerUnitKcal: 144,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'sis-hydro-tablet',
    name: 'SiS GO Hydro Tablet',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'sis-caffeine-gel',
    name: 'SiS GO Isotonic Gel (Caffeine)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 87,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'goldnutrition-isotonic-lemon',
    name: 'GoldNutrition Isotonic Drink (Lemon)',
    unitLabel: 'scoop',
    carbsPerUnitG: 32,
    caloriesPerUnitKcal: 130,
    sodiumPerUnitMg: 240,
  },
  {
    id: 'goldnutrition-isotonic-orange',
    name: 'GoldNutrition Isotonic Drink (Orange)',
    unitLabel: 'scoop',
    carbsPerUnitG: 32,
    caloriesPerUnitKcal: 130,
    sodiumPerUnitMg: 240,
  },
  {
    id: 'goldnutrition-energy-gel-caffeine',
    name: 'GoldNutrition Energy Gel (Caffeine)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'goldnutrition-carb-gel-45',
    name: 'GoldNutrition Carb Gel 45',
    unitLabel: 'gel',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'goldnutrition-salt-caps',
    name: 'GoldNutrition Salt Caps',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 215,
  },
  {
    id: 'decathlon-iso-tablets',
    name: 'Aptonia Hydration Tablets',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'decathlon-energy-chews',
    name: 'Aptonia Energy Chews',
    unitLabel: 'pack',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'decathlon-bar-fruit',
    name: 'Aptonia Fruit Energy Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 28,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'decathlon-bar-protein',
    name: 'Aptonia Protein Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'gu-roctane-vanilla-orange',
    name: 'GU Roctane Gel (Vanilla Orange)',
    unitLabel: 'gel',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'gu-roctane-sea-salt-chocolate',
    name: 'GU Roctane Gel (Sea Salt Chocolate)',
    unitLabel: 'gel',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'gu-roctane-lemon-berry',
    name: 'GU Roctane Gel (Lemon Berry)',
    unitLabel: 'gel',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'gu-roctane-strawberry-kiwi',
    name: 'GU Roctane Gel (Strawberry Kiwi)',
    unitLabel: 'gel',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'gu-roctane-summit-tea-caffeine',
    name: 'GU Roctane Gel (Summit Tea (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'gu-energy-gel-chocolate-outrage',
    name: 'GU Energy Gel (Chocolate Outrage)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'gu-energy-gel-tri-berry',
    name: 'GU Energy Gel (Tri-Berry)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'gu-energy-gel-espresso-love-caffeine',
    name: 'GU Energy Gel (Espresso Love (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'gu-energy-gel-salted-watermelon',
    name: 'GU Energy Gel (Salted Watermelon)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'gu-energy-gel-lemon-sublime',
    name: 'GU Energy Gel (Lemon Sublime)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'gu-chews',
    name: 'GU Energy Chews (pack)',
    unitLabel: 'pack',
    carbsPerUnitG: 46,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 125,
  },
  {
    id: 'powerbar-energy-gel-lemon-lime',
    name: 'PowerBar Energy Gel (Lemon Lime)',
    unitLabel: 'gel',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-energy-gel-cola',
    name: 'PowerBar Energy Gel (Cola)',
    unitLabel: 'gel',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-energy-gel-raspberry',
    name: 'PowerBar Energy Gel (Raspberry)',
    unitLabel: 'gel',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-energy-gel-green-apple',
    name: 'PowerBar Energy Gel (Green Apple)',
    unitLabel: 'gel',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-powergel-original',
    name: 'PowerBar PowerGel Original',
    unitLabel: 'gel',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-powergel-hydro',
    name: 'PowerBar PowerGel Hydro',
    unitLabel: 'gel',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'powerbar-energize-bar',
    name: 'PowerBar Energize Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 43,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'powerbar-natural-energy-bar',
    name: 'PowerBar Natural Energy Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'high5-energy-gel-citrus',
    name: 'HIGH5 Energy Gel (Citrus)',
    unitLabel: 'gel',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'high5-energy-gel-berry',
    name: 'HIGH5 Energy Gel (Berry)',
    unitLabel: 'gel',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'high5-energy-gel-orange',
    name: 'HIGH5 Energy Gel (Orange)',
    unitLabel: 'gel',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'high5-energy-gel-cola-caffeine',
    name: 'HIGH5 Energy Gel (Cola (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'high5-energy-drink',
    name: 'HIGH5 Energy Drink',
    unitLabel: 'scoop',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'high5-zero-tablet',
    name: 'HIGH5 ZERO Tablet',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'high5-energy-bar',
    name: 'HIGH5 Energy Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 190,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'enervit-gel-caffeine',
    name: 'Enervit Gel (Caffeine)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'enervit-isotonic-drink',
    name: 'Enervit Isotonic Drink',
    unitLabel: 'scoop',
    carbsPerUnitG: 32,
    caloriesPerUnitKcal: 128,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'enervit-sport-bar',
    name: 'Enervit Sport Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 170,
    sodiumPerUnitMg: 120,
  },
  {
    id: '226ers-high-energy-gel',
    name: '226ERS High Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 200,
  },
  {
    id: '226ers-isotonic-gel',
    name: '226ERS Isotonic Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 80,
  },
  {
    id: '226ers-energy-drink',
    name: '226ERS Energy Drink',
    unitLabel: 'scoop',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 300,
  },
  {
    id: '226ers-salt-caps',
    name: '226ERS Salt Caps',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 215,
  },
  {
    id: '226ers-energy-bar',
    name: '226ERS Energy Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'neversecond-c30-gel',
    name: 'Neversecond C30 Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'neversecond-c30-gel-caf',
    name: 'Neversecond C30 Gel (Caffeine)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'neversecond-c90-drink',
    name: 'Neversecond C90 High-Carb Drink',
    unitLabel: 'sachet',
    carbsPerUnitG: 90,
    caloriesPerUnitKcal: 360,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'neversecond-e30-electrolyte',
    name: 'Neversecond E30 Electrolyte Drink',
    unitLabel: 'sachet',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 800,
  },
  {
    id: 'naak-waffle',
    name: 'Näak Ultra Energy Waffle',
    unitLabel: 'waffle',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 140,
  },
  {
    id: 'naak-bar',
    name: 'Näak Ultra Energy Bar',
    unitLabel: 'bar',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 170,
  },
  {
    id: 'naak-puree',
    name: 'Näak Ultra Energy Puree',
    unitLabel: 'pouch',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 130,
    sodiumPerUnitMg: 110,
  },
  {
    id: 'naak-drink-mix',
    name: 'Näak Ultra Energy Drink Mix',
    unitLabel: 'scoop',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'isostar-gel',
    name: 'Isostar Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 80,
  },
  {
    id: 'isostar-tablet',
    name: 'Isostar Hydrate Tablet',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'natrend-gel',
    name: 'Nutrend Carbosnack Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 33,
    caloriesPerUnitKcal: 130,
    sodiumPerUnitMg: 70,
  },
  {
    id: 'natrend-drink',
    name: 'Nutrend Isodrinx',
    unitLabel: 'scoop',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 220,
  },
  {
    id: 'sponser-high-energy-gel',
    name: 'SPONSER Liquid Energy Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'sponser-hypotonic',
    name: 'SPONSER Hypotonic Drink',
    unitLabel: 'scoop',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'salted-crackers',
    name: 'Salted Crackers (handful)',
    unitLabel: 'handful',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 220,
  },
  {
    id: 'pretzels-handful',
    name: 'Pretzels (handful)',
    unitLabel: 'handful',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'salted-nuts',
    name: 'Salted Nuts (30g)',
    unitLabel: 'portion',
    carbsPerUnitG: 6,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'raisins',
    name: 'Raisins (30g)',
    unitLabel: 'portion',
    carbsPerUnitG: 23,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'figs-dried',
    name: 'Dried Figs (2 pcs)',
    unitLabel: '2 pcs',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 85,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'apricots-dried',
    name: 'Dried Apricots (30g)',
    unitLabel: 'portion',
    carbsPerUnitG: 19,
    caloriesPerUnitKcal: 70,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'energy-cake',
    name: 'Homemade Energy Cake (slice)',
    unitLabel: 'slice',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'rice-ball',
    name: 'Rice Ball (onigiri)',
    unitLabel: 'unit',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 170,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'tortilla-wrap-half',
    name: 'Tortilla Wrap (half)',
    unitLabel: 'half',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 350,
  },
  {
    id: 'cheese-sandwich-half',
    name: 'Cheese Sandwich (half)',
    unitLabel: 'half',
    carbsPerUnitG: 28,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 450,
  },
  {
    id: 'ham-cheese-sandwich-half',
    name: 'Ham & Cheese Sandwich (half)',
    unitLabel: 'half',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 220,
    sodiumPerUnitMg: 650,
  },
  {
    id: 'peanut-butter-sandwich-half',
    name: 'Peanut Butter Sandwich (half)',
    unitLabel: 'half',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 240,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'banana-bread-slice',
    name: 'Banana Bread (slice)',
    unitLabel: 'slice',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 210,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'muffin',
    name: 'Muffin (small)',
    unitLabel: 'unit',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'croissant',
    name: 'Croissant',
    unitLabel: 'unit',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 230,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'cookies',
    name: 'Cookies (2 pcs)',
    unitLabel: '2 pcs',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 130,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'gummy-bears',
    name: 'Gummy Bears (30g)',
    unitLabel: 'portion',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 95,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'jelly-candies',
    name: 'Jelly Candies (30g)',
    unitLabel: 'portion',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 95,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'cola-cup',
    name: 'Cola (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'ginger-ale-cup',
    name: 'Ginger Ale (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 28,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 15,
  },
  {
    id: 'isotonic-cup',
    name: 'Isotonic Drink (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 16,
    caloriesPerUnitKcal: 64,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'coffee-small',
    name: 'Coffee (small, sweetened)',
    unitLabel: 'cup',
    carbsPerUnitG: 10,
    caloriesPerUnitKcal: 40,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'tea-sweet',
    name: 'Tea (sweetened)',
    unitLabel: 'cup',
    carbsPerUnitG: 12,
    caloriesPerUnitKcal: 50,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'hot-chocolate',
    name: 'Hot Chocolate (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 150,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'soup-noodle',
    name: 'Noodle Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 900,
  },
  {
    id: 'ramen-bowl',
    name: 'Ramen (small bowl)',
    unitLabel: 'bowl',
    carbsPerUnitG: 55,
    caloriesPerUnitKcal: 320,
    sodiumPerUnitMg: 1200,
  },
  {
    id: 'pasta-bolognese',
    name: 'Pasta Bolognese (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 350,
    sodiumPerUnitMg: 550,
  },
  {
    id: 'pasta-olive-oil',
    name: 'Pasta with Olive Oil (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 42,
    caloriesPerUnitKcal: 300,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'rice-chicken',
    name: 'Rice with Chicken (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 330,
    sodiumPerUnitMg: 400,
  },
  {
    id: 'mashed-potato-salty',
    name: 'Salty Mashed Potatoes (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 450,
  },
  {
    id: 'pizza-margherita-slice',
    name: 'Pizza Margherita (slice)',
    unitLabel: 'slice',
    carbsPerUnitG: 34,
    caloriesPerUnitKcal: 270,
    sodiumPerUnitMg: 620,
  },
  {
    id: 'pizza-pepperoni-slice',
    name: 'Pizza Pepperoni (slice)',
    unitLabel: 'slice',
    carbsPerUnitG: 33,
    caloriesPerUnitKcal: 300,
    sodiumPerUnitMg: 760,
  },
  {
    id: 'broth-salty',
    name: 'Salty Broth (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 2,
    caloriesPerUnitKcal: 10,
    sodiumPerUnitMg: 700,
  },
  {
    id: 'chicken-broth',
    name: 'Chicken Broth (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 2,
    caloriesPerUnitKcal: 15,
    sodiumPerUnitMg: 700,
  },
  {
    id: 'lentil-soup',
    name: 'Lentil Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 140,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'oatmeal',
    name: 'Oatmeal (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'porridge-nestum',
    name: 'Nestum Porridge (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 170,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'orange',
    name: 'Orange (small)',
    unitLabel: 'unit',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 62,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'apple',
    name: 'Apple (small)',
    unitLabel: 'unit',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 80,
    sodiumPerUnitMg: 2,
  },
  {
    id: 'watermelon-cup',
    name: 'Watermelon (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 11,
    caloriesPerUnitKcal: 45,
    sodiumPerUnitMg: 2,
  },
  {
    id: 'grapes-cup',
    name: 'Grapes (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 104,
    sodiumPerUnitMg: 2,
  },
  {
    id: 'cantaloupe-cup',
    name: 'Melon (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 13,
    caloriesPerUnitKcal: 55,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'salted-chips-small',
    name: 'Salted Chips (small pack)',
    unitLabel: 'small pack',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 150,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'salted-popcorn',
    name: 'Salted Popcorn (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 80,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'cured-ham',
    name: 'Cured Ham / Prosciutto (portion)',
    unitLabel: 'portion',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 800,
  },
  {
    id: 'salami',
    name: 'Salami (portion)',
    unitLabel: 'portion',
    carbsPerUnitG: 1,
    caloriesPerUnitKcal: 150,
    sodiumPerUnitMg: 700,
  },
  {
    id: 'pickle',
    name: 'Pickle (1 unit)',
    unitLabel: 'unit',
    carbsPerUnitG: 1,
    caloriesPerUnitKcal: 5,
    sodiumPerUnitMg: 400,
  },
  {
    id: 'olives',
    name: 'Olives (10 pcs)',
    unitLabel: '10 pcs',
    carbsPerUnitG: 2,
    caloriesPerUnitKcal: 50,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'salted-cucumber',
    name: 'Salted Cucumber Slices',
    unitLabel: 'cup',
    carbsPerUnitG: 3,
    caloriesPerUnitKcal: 15,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'chocolate-dark-30g',
    name: 'Dark Chocolate (30g)',
    unitLabel: 'portion',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 170,
    sodiumPerUnitMg: 5,
  },
  {
    id: 'chocolate-milk',
    name: 'Chocolate Milk (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 190,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'custard',
    name: 'Custard (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 120,
  },
  {
    id: 'ice-cream-small',
    name: 'Ice Cream (small)',
    unitLabel: 'cup',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 80,
  },
  {
    id: 'coke-flat',
    name: 'Flat Cola (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 26,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'sports-drink-cup',
    name: 'Sports Drink (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 16,
    caloriesPerUnitKcal: 64,
    sodiumPerUnitMg: 120,
  },
  {
    id: '226ers-high-energy-gel-lemon',
    name: '226ERS High Energy Gel (Lemon)',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 200,
  },
  {
    id: '226ers-high-energy-gel-cola-caffeine',
    name: '226ERS High Energy Gel (Cola (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 200,
  },
  {
    id: '226ers-high-energy-gel-orange',
    name: '226ERS High Energy Gel (Orange)',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 200,
  },
  {
    id: '226ers-high-energy-gel-strawberry',
    name: '226ERS High Energy Gel (Strawberry)',
    unitLabel: 'gel',
    carbsPerUnitG: 40,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 200,
  },
  {
    id: '226ers-isotonic-gel-apple',
    name: '226ERS Isotonic Gel (Apple)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 80,
  },
  {
    id: '226ers-isotonic-gel-tropical',
    name: '226ERS Isotonic Gel (Tropical)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 80,
  },
  {
    id: '226ers-isotonic-gel-cherry',
    name: '226ERS Isotonic Gel (Cherry)',
    unitLabel: 'gel',
    carbsPerUnitG: 22,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 80,
  },
  {
    id: 'enervit-gel-lemon',
    name: 'Enervit Gel (Lemon)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'enervit-gel-orange',
    name: 'Enervit Gel (Orange)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'enervit-gel-cola-caffeine',
    name: 'Enervit Gel (Cola (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 60,
  },
  {
    id: 'goldnutrition-energy-gel-lemon',
    name: 'GoldNutrition Energy Gel (Lemon)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'goldnutrition-energy-gel-orange',
    name: 'GoldNutrition Energy Gel (Orange)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'goldnutrition-energy-gel-strawberry',
    name: 'GoldNutrition Energy Gel (Strawberry)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'goldnutrition-energy-gel-cola-caffeine',
    name: 'GoldNutrition Energy Gel (Cola (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'decathlon-aptogn-lemon',
    name: 'Aptonia Energy Gel (Lemon)',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'decathlon-aptogn-red-fruits',
    name: 'Aptonia Energy Gel (Red Fruits)',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'decathlon-aptogn-cola-caffeine',
    name: 'Aptonia Energy Gel (Cola (Caffeine))',
    unitLabel: 'gel',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 100,
  },
  {
    id: 'precision-pf30-neutral',
    name: 'Precision Fuel PF 30 Gel (Neutral)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'precision-pf30-citrus',
    name: 'Precision Fuel PF 30 Gel (Citrus)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'precision-pf30-mint',
    name: 'Precision Fuel PF 30 Gel (Mint)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'neversecond-c30-gel-neutral',
    name: 'Neversecond C30 Gel (Neutral)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'neversecond-c30-gel-citrus',
    name: 'Neversecond C30 Gel (Citrus)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'neversecond-c30-gel-berry',
    name: 'Neversecond C30 Gel (Berry)',
    unitLabel: 'gel',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'high5-zero-tablet-orange',
    name: 'HIGH5 ZERO Tablet (Orange)',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'high5-zero-tablet-lemon',
    name: 'HIGH5 ZERO Tablet (Lemon)',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'high5-zero-tablet-berry',
    name: 'HIGH5 ZERO Tablet (Berry)',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'high5-zero-tablet-tropical',
    name: 'HIGH5 ZERO Tablet (Tropical)',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'banana-ripe',
    name: 'Banana (ripe)',
    unitLabel: 'unit',
    carbsPerUnitG: 27,
    caloriesPerUnitKcal: 105,
    sodiumPerUnitMg: 1,
  },
  {
    id: 'banana-half',
    name: 'Banana (half)',
    unitLabel: 'half',
    carbsPerUnitG: 14,
    caloriesPerUnitKcal: 52,
    sodiumPerUnitMg: 1,
  },
  {
    id: 'orange-slices-small',
    name: 'Orange Slices (small cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 12,
    caloriesPerUnitKcal: 55,
    sodiumPerUnitMg: 0,
  },
  {
    id: 'apple-sauce-pouch',
    name: 'Apple Sauce (pouch)',
    unitLabel: 'pouch',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 80,
    sodiumPerUnitMg: 10,
  },
  {
    id: 'fruit-cake-slice',
    name: 'Fruit Cake (slice)',
    unitLabel: 'slice',
    carbsPerUnitG: 38,
    caloriesPerUnitKcal: 230,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'bread-white-roll',
    name: 'White Bread Roll',
    unitLabel: 'unit',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'bread-baguette-piece',
    name: 'Baguette (piece)',
    unitLabel: 'piece',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 190,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'toast-honey',
    name: 'Toast with Honey',
    unitLabel: 'unit',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 170,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'toast-nutella',
    name: 'Toast with Chocolate Spread',
    unitLabel: 'unit',
    carbsPerUnitG: 32,
    caloriesPerUnitKcal: 220,
    sodiumPerUnitMg: 150,
  },
  {
    id: 'tortilla-chips',
    name: 'Tortilla Chips (handful)',
    unitLabel: 'handful',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 150,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'salted-broth-strong',
    name: 'Extra Salty Broth (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 1,
    caloriesPerUnitKcal: 5,
    sodiumPerUnitMg: 900,
  },
  {
    id: 'miso-soup',
    name: 'Miso Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 6,
    caloriesPerUnitKcal: 40,
    sodiumPerUnitMg: 800,
  },
  {
    id: 'tomato-soup',
    name: 'Tomato Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 15,
    caloriesPerUnitKcal: 90,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'vegetable-soup-thick',
    name: 'Thick Vegetable Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 550,
  },
  {
    id: 'mashed-potato-butter',
    name: 'Mashed Potatoes with Butter (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 220,
    sodiumPerUnitMg: 350,
  },
  {
    id: 'rice-soup',
    name: 'Rice Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 20,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 600,
  },
  {
    id: 'pasta-cheese',
    name: 'Pasta with Cheese (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 42,
    caloriesPerUnitKcal: 320,
    sodiumPerUnitMg: 400,
  },
  {
    id: 'pasta-soup',
    name: 'Pasta Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 700,
  },
  {
    id: 'pizza-veg-slice',
    name: 'Pizza Veggie (slice)',
    unitLabel: 'slice',
    carbsPerUnitG: 35,
    caloriesPerUnitKcal: 260,
    sodiumPerUnitMg: 600,
  },
  {
    id: 'hot-dog-half',
    name: 'Hot Dog (half)',
    unitLabel: 'half',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 180,
    sodiumPerUnitMg: 600,
  },
  {
    id: 'wrap-tuna-half',
    name: 'Tuna Wrap (half)',
    unitLabel: 'half',
    carbsPerUnitG: 25,
    caloriesPerUnitKcal: 200,
    sodiumPerUnitMg: 500,
  },
  {
    id: 'cheese-cubes-salty',
    name: 'Cheese Cubes (salty portion)',
    unitLabel: 'portion',
    carbsPerUnitG: 2,
    caloriesPerUnitKcal: 110,
    sodiumPerUnitMg: 250,
  },
  {
    id: 'soup-chicken-noodles',
    name: 'Chicken Noodle Soup (cup)',
    unitLabel: 'cup',
    carbsPerUnitG: 18,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 750,
  },
  {
    id: 'saltstick-fastchews',
    name: 'SaltStick FastChews (2 tabs)',
    unitLabel: '2 tabs',
    carbsPerUnitG: 3,
    caloriesPerUnitKcal: 15,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'succeed-scaps',
    name: 'Succeed! S-Caps (capsule)',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 340,
  },
  {
    id: 'hammer-endurolytes',
    name: 'Hammer Endurolytes (capsule)',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 40,
  },
  {
    id: 'gu-roctane-caps',
    name: 'GU Roctane Electrolyte Capsule',
    unitLabel: 'capsule',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 190,
  },
  {
    id: 'nuun-sport-tablet',
    name: 'Nuun Sport Tablet',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 300,
  },
  {
    id: 'nuun-endurance-tablet',
    name: 'Nuun Endurance Tablet',
    unitLabel: 'tablet',
    carbsPerUnitG: 0,
    caloriesPerUnitKcal: 0,
    sodiumPerUnitMg: 380,
  },
  {
    id: 'clif-bar-chocolate-chip',
    name: 'Clif Bar (Chocolate Chip)',
    unitLabel: 'bar',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 250,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'clif-bar-oatmeal-raisin',
    name: 'Clif Bar (Oatmeal Raisin)',
    unitLabel: 'bar',
    carbsPerUnitG: 45,
    caloriesPerUnitKcal: 250,
    sodiumPerUnitMg: 200,
  },
  {
    id: 'clif-bloks-citrus',
    name: 'Clif Bloks (Citrus, sleeve)',
    unitLabel: 'sleeve',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 70,
  },
  {
    id: 'clif-bloks-mountain-berry',
    name: 'Clif Bloks (Mountain Berry, sleeve)',
    unitLabel: 'sleeve',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 70,
  },
  {
    id: 'clif-bloks-black-cherry',
    name: 'Clif Bloks (Black Cherry, sleeve)',
    unitLabel: 'sleeve',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 70,
  },
  {
    id: 'clif-bloks-caffeine',
    name: 'Clif Bloks (Caffeine, sleeve)',
    unitLabel: 'sleeve',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 70,
  },
  {
    id: 'stinger-waffle',
    name: 'Honey Stinger Waffle',
    unitLabel: 'waffle',
    carbsPerUnitG: 21,
    caloriesPerUnitKcal: 150,
    sodiumPerUnitMg: 90,
  },
  {
    id: 'stinger-gel',
    name: 'Honey Stinger Gel',
    unitLabel: 'gel',
    carbsPerUnitG: 24,
    caloriesPerUnitKcal: 100,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'stinger-chews',
    name: 'Honey Stinger Chews (pack)',
    unitLabel: 'pack',
    carbsPerUnitG: 39,
    caloriesPerUnitKcal: 160,
    sodiumPerUnitMg: 50,
  },
  {
    id: 'powerbar-powergel-shots-cola',
    name: 'PowerBar PowerGel Shots (Cola)',
    unitLabel: 'pack',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 180,
  },
  {
    id: 'powerbar-powergel-shots-orange',
    name: 'PowerBar PowerGel Shots (Orange)',
    unitLabel: 'pack',
    carbsPerUnitG: 30,
    caloriesPerUnitKcal: 120,
    sodiumPerUnitMg: 180,
  },
]
